import { render } from "./PoswiseSale.vue?vue&type=template&id=263541ca"
import script from "./PoswiseSale.vue?vue&type=script&lang=js"
export * from "./PoswiseSale.vue?vue&type=script&lang=js"

import "./PoswiseSale.vue?vue&type=style&index=0&id=263541ca&lang=css"

import exportComponent from "F:\\xampp\\htdocs\\HAVELI\\havelidashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__